import React, { useState } from "react";
import TopBar from "../../components/admin/TopBar";
import CreateBulletinModal from "../../components/admin/CreateBulletinModal";
import EditBulletinModal from "../../components/admin/EditBulletinModal";

import DataTable from "react-data-table-component";
import useFetch from "../../hooks/useFetch";
import axios from "axios";
import Swal from "sweetalert2";

import { useAuth } from "../../context/AuthContext";
import { ucwords } from "../../utils/Ucwords";
import { LongDate } from "../../utils/LongDate";

const BulletinPage = () => {
  const API_URL = process.env.REACT_APP_API_URL;
  const { user } = useAuth();

  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [selectedBulletin, setSelectedBulletin] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");

  const openCreateModal = () => setIsCreateModalOpen(true);
  const closeCreateModal = () => setIsCreateModalOpen(false);

  const openEditModal = (hiring) => {
    setSelectedBulletin(hiring);
    setIsEditModalOpen(true);
  };

  const handleEdit = (hiring) => {
    openEditModal(hiring);
  };

  const closeEditModal = () => {
    setSelectedBulletin(null);
    setIsEditModalOpen(false);
  };

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    });

    if (result.isConfirmed) {
      try {
        const token = localStorage.getItem("token"); // Retrieve token from local storage
        const deleteBulletin = await axios.delete(`${API_URL}/bulletin/${id}`, {
          headers: {
            Authorization: `Bearer ${token}`, // Attach token to headers
          },
        });
        const { message } = deleteBulletin.data;

        // Show success message
        Swal.fire({
          title: "Deleted!",
          text: message,
          icon: "success",
          showConfirmButton: false,
          timer: 3000,
        });

        refetch();
      } catch (error) {
        console.error("Error deleting bulletin position:", error);
        Swal.fire(
          "Error!",
          "There was an error deleting the bulletin.",
          "error"
        );
      }
    }
  };

  const { data, refetch } = useFetch(`${API_URL}/bulletin`);

  const filteredBulletin = data.filter((row) => {
    return (
      `${ucwords(row.header_name)}`
        .toLowerCase()
        .includes(searchTerm.toLowerCase()) ||
      row.event_date.toLowerCase().includes(searchTerm.toLowerCase()) ||
      row.description.toLowerCase().includes(searchTerm.toLowerCase())
    );
  });

  const columns = [
    {
      name: "Header",
      selector: (row) => row.header_name,
      cell: (row) => (
        <div className="font-semibold text-sm">{ucwords(row.header_name)}</div>
      ),
      sortable: true,
    },
    {
      name: "Event Date",
      selector: (row) => `${LongDate(row.event_date)}`,
      sortable: true,
    },
    {
      name: "Status",
      selector: (row) =>
        row.bulletin_status === 0 ? (
          <span className="text-green-600">Active</span>
        ) : (
          <span className="text-orange-600">Deactivated</span>
        ),
      sortable: true,
    },
    {
      name: "Description",
      selector: (row) => row.description,
      cell: (row) => (
        <div className=" truncate max-w-xs">{ucwords(row.description)}</div>
      ),
    },
    {
      name: "Action",
      cell: (row) => (
        <div className="flex space-x-2">
          {(user.role_name === "Head Admin" ||
            user.role_name === "Senior Admin") && (
            <>
              <button
                className="text-blue-500 hover:text-blue-700"
                onClick={() => handleEdit(row)}
              >
                <i className="fa-solid fa-pen-to-square"></i>
              </button>
              <button
                className="text-red-500 hover:text-red-700"
                onClick={() => handleDelete(row.id)}
              >
                <i className="fa-solid fa-trash"></i>
              </button>
            </>
          )}
        </div>
      ),
    },
  ];

  const customStyles = {
    headCells: {
      style: {
        fontWeight: "bold",
        fontSize: "14px",
      },
    },
  };
  return (
    <>
      <TopBar />
      <CreateBulletinModal
        isOpen={isCreateModalOpen}
        onClose={closeCreateModal}
        onSuccess={refetch}
      />

      <EditBulletinModal
        isOpen={isEditModalOpen}
        onClose={closeEditModal}
        onSuccess={refetch}
        bulletin={selectedBulletin}
      />

      <div className="p-2 mt-16">
        <div className="flex flex-col">
          <div className="flex pb-2 justify-between border-b-2">
            <div className="font-semibold text-xl">
              <label htmlFor="">Bulletin</label>
            </div>
            <button
              onClick={openCreateModal}
              className="block text-white bg-[var(--customRed)] hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center"
              type="button"
            >
              Create Newspaper
            </button>
          </div>
          <div className="mt-3">
            <div className="flex justify-end gap-3">
              <label htmlFor="search" className="mt-1.5">
                Search:
              </label>
              <input
                type="text"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="form-input p-1.5 block border-gray-300 rounded-lg shadow-sm focus:ring-green-800 focus:border-green-800 mb-1"
              />
            </div>
            <DataTable
              columns={columns}
              data={filteredBulletin}
              pagination
              responsive
              highlightOnHover
              pointerOnHover
              paginationPerPage={10}
              paginationRowsPerPageOptions={[5, 10, 15, 20]}
              customStyles={customStyles}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default BulletinPage;
